<template>
  <div>
    <maritimeService
      :name="heading"
      subProps="Marine industry software designed to streamline operations and improve efficiency"
    />
    <v-container>
      <v-row class="row pt-5">
        <v-col class="mt-sm-20" m="12" md="8" lg="8">
          <div>
            <strong
              >Welcome to mDrive: Revolutionizing Maritime File
              Management</strong
            >
            <br /><br />
            At mDrive, we're dedicated to transforming the way maritime
            companies manage their files. Our cutting-edge solution offers
            seamless synchronization and secure file sharing tailored explicitly
            for the maritime industry. Say goodbye to file management
            complexities and embrace effortless, secure data handling for
            vessels and onshore operations.
            <br /><br />
            <strong
              >Streamlined File Synchronization for Maritime Excellence</strong
            >
            <br /><br />
            Empower your maritime operations with our innovative file
            synchronization solution. Seamlessly sync files between onshore
            management and vessels, ensuring data integrity and accessibility
            where and when you need it. With industry-standard encryption and
            robust scanning for viruses and malware, mDrive guarantees the
            highest level of data security at sea.
            <br /><br />

            <strong>Key Features and Benefits</strong>
            <br /><br />
            <div class="texv">
              <v-icon color="indigo darken-4" x-large>
                mdi mdi-cloud-cog-outline </v-icon
              >&nbsp;
              <span class="sicon"><b>Secure Cloud-Based Sync:</b></span>
              <br />
              <p class="texv">
                Safeguard your data with our secure cloud-based synchronization
                exclusively designed for selected vessels.
              </p>
              <br />
              <v-icon color="indigo darken-4" x-large>
                mdi mdi-file-cog-outline </v-icon
              >&nbsp;
              <span class="sicon"><b>Effortless File Management:</b></span>
              <br />
              <p class="texv">
                Enjoy efficient admin controls for large file uploads and
                empower vessel users with user-friendly file utilities.
              </p>
              <br />
              <v-icon color="indigo darken-4" x-large>
                mdi mdi-cog-sync-outline</v-icon
              >&nbsp;
              <span class="sicon"><b>Seamless Integration:</b></span>
              <br />
              <p class="texv">
                Integrate with ERP systems effortlessly, streamlining your
                entire data management process.
              </p>
              <br />
              <v-icon color="indigo darken-4" x-large> mdi mdi-cached</v-icon
              >&nbsp; <span class="sicon"><b>Uninterrupted Transfers:</b></span>
              <br />
              <p class="texv">
                Experience seamless transfer acceleration for uploads and
                downloads, ensuring efficiency and reliability.
              </p>
              <br />
              <v-icon color="indigo darken-4" x-large>
                mdi mdi-arrow-decision</v-icon
              >&nbsp; <span class="sicon"><b>Flexible Licensing:</b></span>
              <br />
              <p class="texv">
                Tailored licensing models to accommodate your fleet size and
                storage needs transparently.
              </p>
              <br />
              <v-icon color="indigo darken-4" x-large
                >mdi mdi-shield-outline</v-icon
              >&nbsp;
              <span class="sicon"
                ><b>Threat Intelligence powered by SophosLabs:</b></span
              >
              <br />
              <p class="texv">
                Enhance your security with Threat Intelligence powered by
                SophosLabs, offering robust virus scanning for attachments and
                uploaded files. Safeguard your system against potential threats
                with advanced protection backed by cutting-edge technology.
              </p>
              <br />
              <v-icon color="indigo darken-4" x-large>
                mdi mdi-cloud-circle</v-icon
              >&nbsp; <span class="sicon"><b>mDrive SecureShip:</b></span>
              <br />
              <p class="texv">
                mDrive SecureShip: MAC-Based Lockdown for Maritime File Security
                <br />Our innovative technology, mDrive, implements an
                additional layer of security by locking file access to the
                unique MAC address of the server deployed within the licensed
                vessel. This exclusive feature guarantees that the utility
                remains inaccessible and inoperable outside of the designated
                vessel, ensuring comprehensive security and control over file
                sharing operations
              </p>
            </div>
            <br />
          </div>

          <div align-self="center" class="mx-auto">
            <v-img
              src="@/assets/KeyFeatures.jpg"
              class="mx-auto"
              width="100px;"
            />
          </div>

          <div class="v-responsive__content pt-5">
            <v-theme-provider dark>
              <base-section class="blue darken-4 " space="20">
                <v-container>
                  <span class="white--text">
                    mDrive provides quality, speed, and low-bandwidth capability
                    through a fully-managed platform hosted by a secure and
                    scalable cloud service provider
                  </span>
                </v-container>
              </base-section>
            </v-theme-provider>
          </div>

          <div class="pt-5">
            <span
              >Our shipping clients experience the following return on
              investment (ROI) with mDrive:</span
            >
            <br /><br />
            <span
              >mDrive's vessel file-sharing replication module addresses the
              following challenges:</span
            >
            <br /><br />
            <ul>
              <li>
                Reducing costs associated with unstable internet connectivity
                and the necessity to retransmit interrupted data on vessels.
              </li>
              <li>
                Minimizing disruptions in ship operations caused by unreliable
                data delivery.
              </li>
              <li>
                Eliminating delays in vessel software updates.
              </li>
              <li>
                Lowering repetitive expenses related to the development,
                maintenance, and management of data transmission code.
              </li>
              <li>
                Ensuring compliance to stay relevant.
              </li>
              <li>
                Preventing business downtime due to malware-infected files
                through our solution, which scans for viruses and malware.
              </li>
            </ul>
          </div>

          <div class="v-responsive__content pt-5">
            <v-theme-provider dark>
              <base-section class="blue darken-4 " space="20">
                <v-container>
                  <span class="white--text">
                    Establish synchronization rules to replicate data between
                    vessels at sea and headquarters onshore using mDrive,
                    without relying on central email servers, encountering size
                    limits, or restarting data transfers from scratch.
                  </span>
                </v-container>
              </base-section>
            </v-theme-provider>
          </div>

          <!-- <v-row class="pt-3">
            <v-col v-for="(feature, i) in features" :key="i" cols="6" md="6">
              <base-avatar-card v-bind="feature" align="left" horizontal />
            </v-col>
          </v-row> -->

          <template>
            <v-row class="pt-3">
              <v-col
                v-for="(feature, i) in features"
                :key="i"
                cols="12"
                md="6"
                lg="5"
                xl="3"
              >
                <base-avatar-card v-bind="feature" align="left" horizontal />
              </v-col>
            </v-row>
          </template>

          <div class="v-responsive__content pt-5">
            <v-theme-provider dark>
              <base-section class="blue darken-4 " space="20">
                <v-container>
                  <span class="white--text">
                    Data Synchronization and Replication Solution Tailored for
                    Contemporary Businesses A Dependable and Scalable System for
                    Synchronizing and Replicating Data, Suitable for Businesses
                    of Any Scale
                  </span>
                </v-container>
              </base-section>
            </v-theme-provider>
          </div>

          <div class="pt-5">
            <strong>Join the Maritime Tech Revolution Today</strong>
            <br /><br />
            Experience the power of mDrive firsthand! Book a personalized demo
            now and witness how our solution revolutionizes maritime file
            management. Say hello to effortless file sync and embrace a new era
            of secure, streamlined data management for your maritime operations.
            <br /><br />
            <strong
              >Explore the Future of Maritime File Management with mDrive. Book
              Your Demo Today!</strong
            >
          </div>
        </v-col>
        <v-col sm="12" md="4" lg="4"> <base-request /> </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import maritimeService from "../../components/maritime-service.vue";
export default {
  components: {
    maritimeService
  },

  data: () => ({ heading: "" }),
  mounted() {
    this.heading = "mDrive Maritime File Sharing";
  },

  data: () => ({
    features: [
      {
        color: "blue darken-2",
        dark: true,
        title: "Lightning-Fast Data Transfers",
        icon: "mdi-swap-horizontal",
        text:
          "Don't let sluggish data transfers impede your business. Our high-speed transfer capabilities guarantee that your data reaches its destination instantly."
      },
      {
        color: "blue darken-2",
        dark: true,
        title: "Streamlined Data Transfer",
        icon: "mdi-transfer",
        text:
          "Make data transfer a breeze. Just designate a folder from your carrier’s device to the HQ, and every time the data is updated, it seamlessly moves between devices."
      },
      {
        color: "blue darken-2",
        dark: true,
        title: "Steadfast Connectivity",
        icon: "mdi-access-point",
        text:
          "No need to fret about connectivity outages. If a carrier loses connectivity, files automatically resume from where they left off. Reduce your data usage by up to 50%."
      },
      {
        color: "blue darken-2",
        dark: true,
        title: "Seamless Software Integration (ITSM)",
        icon: "mdi-cog-transfer",
        text:
          "mDrive offers API integrations, enabling direct data transfers in a format compatible with your preferred ERP or CRM."
      },
      {
        color: "blue darken-2",
        dark: true,
        title: "Live Monitoring and Analytics",
        icon: "mdi-monitor-dashboard",
        text:
          "Stay ahead with live monitoring and analytics. Make informed decisions with minute-by-minute insights into your data landscape."
      },
      {
        color: "blue darken-2",
        dark: true,
        title: "Adherence to Compliance Standards",
        icon: "mdi-chart-line",
        text:
          "Meet and surpass industry-specific compliance standards. Whether it's HIPAA or GDPR, mDrive has you covered."
      },
      {
        color: "blue darken-2",
        dark: true,
        title: "Complete Device Synchronization",
        icon: "mdi-cellphone-link",
        text:
          "Achieve complete synchronization between devices. Any changes made on this device or member devices are automatically synchronized."
      },
      {
        color: "blue darken-2",
        dark: true,
        title: "Flexible File Handling",
        icon: "mdi-file-cog-outline",
        text:
          "Harness regular expressions to include or exclude specific file types in the synchronization process, such as .doc, .docx, or .pdf."
      },
      {
        color: "blue darken-2",
        dark: true,
        title: "Automated File Deletion",
        icon: "mdi-file-remove-outline",
        text:
          "Activate this feature to automatically remove files from the source folder after successful transfer to all member devices. Prior to deletion, back up the files to a specified location, ensuring data safety."
      },
      {
        color: "blue darken-2",
        dark: true,
        title: "Timely Synchronization",
        icon: "mdi-autorenew",
        text:
          "Execute your sync jobs on a predefined schedule, optimizing resource usage and ensuring timely data transfers."
      }
    ]
  })
};
</script>

<style scoped>
.row {
  text-align: justify;
}
h3 {
  font-size: 20px;
  color: #033261;
}

@media (max-width: 960px) {
  .mt-sm-20 {
    margin-top: 150px;
    padding: 25px;
  }
}

@media (max-width: 800px) {
  .mt-sm-20 {
    margin-top: 140px;
    padding: 25px;
  }
}

@media (max-width: 600px) {
  .mt-sm-20 {
    margin-top: 155px;
    padding: 25px;
  }
}

@media (max-width: 500px) {
  .mt-sm-20 {
    margin-top: 200px;
    padding: 25px;
  }
}

@media (max-width: 400px) {
  .mt-sm-20 {
    margin-top: 220px;
    padding: 25px;
  }
}
</style>
